function isEnabled(value, defaultValue = false) {
  if (value === undefined || value === null || value === '') {
    return defaultValue;
  }
  const normalized = String(value).trim().toLowerCase();
  return ['1', 'true', 'yes', 'on'].includes(normalized);
}

// Build-time flag (Vue CLI injects process.env.VUE_APP_* during build).
// Default is false so the tour stays disabled unless explicitly enabled.
export const ENABLE_STAFF_PORTAL_TOUR = isEnabled(
  process.env.VUE_APP_ENABLE_STAFF_PORTAL_TOUR,
  false
);

// The analytics can launch before the separately deployed AI assistant.
export const ENABLE_DASHBOARD_ASSISTANT = isEnabled(
  process.env.VUE_APP_ENABLE_DASHBOARD_ASSISTANT,
  false
);

// Presentation only: both layouts use the same rates and deferral exclusions.
// Keep the familiar layout in production unless a build explicitly opts in.
// CityAnalytics can override this default with ?dashboardRedesign=true or false.
export const ENABLE_DASHBOARD_REDESIGN = isEnabled(
  process.env.VUE_APP_ENABLE_DASHBOARD_REDESIGN,
  false
);

// Keep the detail implementation available while its presentation is revised.
export const ENABLE_DASHBOARD_COMPLIANCE_DETAILS = isEnabled(
  process.env.VUE_APP_ENABLE_DASHBOARD_COMPLIANCE_DETAILS,
  false
);
